import { render, staticRenderFns } from "./StubWidget.vue?vue&type=template&id=ea1d6bcc&"
import script from "./StubWidget.vue?vue&type=script&lang=js&"
export * from "./StubWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports